var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgLogoOvelia = function SvgLogoOvelia(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 49,
    height: 26,
    viewBox: "0 0 49 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "logo_ovelia_svg__Group"
  }, /*#__PURE__*/React.createElement("path", {
    id: "logo_ovelia_svg__Vector",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M43.0069 24.3015C40.2758 22.8152 37.4129 22.0425 34.484 21.9952C32.6706 23.0929 30.676 23.8722 28.547 24.3015H43.0069Z",
    fill: "#D6AE23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_ovelia_svg__Vector_2",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M40.8642 14.8921C37.5922 14.939 34.5402 15.7843 31.868 17.3214C30.3307 20.0952 28.1102 22.4729 25.302 24.2851C31.8589 24.0538 37.4855 20.6655 40.8642 14.8921Z",
    fill: "#D6AE23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_ovelia_svg__Vector_3",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M33.9638 7.78819C31.1795 9.50694 28.9662 11.7921 27.4084 14.4773C27.4358 17.6921 26.6692 20.914 25.1066 23.946C30.6572 20.3601 33.8631 14.5257 33.9638 7.78819ZM0.00488119 24.9327C2.63835 24.8667 4.73205 24.8382 7.36628 24.7894L15.2659 24.7081C20.5328 24.6542 19.3276 24.6472 24.5941 24.6394C29.8615 24.646 28.6562 24.6538 33.9231 24.7069L41.8232 24.789C44.4566 24.8378 46.5507 24.8663 49.1845 24.9327C46.5507 24.9991 44.4566 25.028 41.8232 25.0765L33.9231 25.1585C28.6562 25.212 29.8615 25.2194 24.5941 25.2261C19.3276 25.2187 20.5328 25.2112 15.2659 25.1573L7.3659 25.0757C4.73205 25.0273 2.63835 24.9991 0.00450134 24.9327M6.18192 24.3015C8.913 22.8151 11.7763 22.0425 14.7045 21.9952C16.5179 23.0929 18.5128 23.8722 20.6415 24.3015H6.18192Z",
    fill: "#D6AE23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_ovelia_svg__Vector_4",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.32507 14.8921C11.5967 14.939 14.6483 15.7843 17.3206 17.3214C18.8582 20.0952 21.0787 22.4729 23.8866 24.2851C17.33 24.0538 11.7034 20.6655 8.32507 14.8921Z",
    fill: "#D6AE23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_ovelia_svg__Vector_5",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M15.225 7.78818C18.0092 9.50693 20.223 11.7921 21.7811 14.4772C21.7534 17.6921 22.5199 20.914 24.0818 23.946C18.5319 20.3601 15.3256 14.5257 15.225 7.78818Z",
    fill: "#D6AE23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_ovelia_svg__Vector_6",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M24.5942 5.21039C21.3484 11.2151 21.348 18.0612 24.5942 24.0987C27.8411 18.0612 27.8407 11.2151 24.5942 5.21039Z",
    fill: "#D6AE23"
  }), /*#__PURE__*/React.createElement("path", {
    id: "logo_ovelia_svg__Vector_7",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M16.9892 16.6937C15.6134 13.9847 14.8917 10.9944 14.8442 7.79406L14.8336 7.09015L15.4208 7.45265C16.1807 7.92167 16.9102 8.44072 17.605 9.00656C18.3559 5.28898 20.6255 2.33234 24.5941 2.33234C28.5631 2.33234 30.8319 5.28937 31.5832 9.00695C32.2781 8.44069 33.0079 7.92138 33.7681 7.45226L34.355 7.09015L34.3443 7.79406C34.2965 10.9944 33.5748 13.9851 32.1994 16.6937C33.4014 16.0517 34.6678 15.5463 35.9762 15.1862C36.2193 14.1816 36.3492 13.0905 36.3492 11.9132C36.3492 4.71632 31.5927 0.666321 24.5941 0.666321C17.5958 0.666321 12.8398 4.71632 12.8398 11.9132C12.8398 13.0905 12.9693 14.1816 13.2128 15.1862C14.5212 15.546 15.7875 16.0515 16.9892 16.6937Z",
    fill: "#41422D"
  }))));
};
export default SvgLogoOvelia;